export default __webpack_public_path__ + "static/media/safepay-black.32e93bc4.svg";